import '../stylesheets/application_login';

$(() => {
  let mmberNodeList = document.querySelectorAll('.js-member-login-factor');
  let memberNode = Array.prototype.slice.call(mmberNodeList, 0);
  memberNode.forEach(function (element, index) {
    element.onkeydown = event => {
      if (event.key === 'Enter') { document.members_login.submit(); }
    }
  });

  let associateMemberNodeList = document.querySelectorAll('.js-associate-member-login-factor');
  let associateMemberNode = Array.prototype.slice.call(associateMemberNodeList, 0);
  associateMemberNode.forEach(function (element, index) {
    element.onkeydown = event => {
      if (event.key === 'Enter') { document.associate_members_login.submit(); }
    }
  });
});
